import lodash from 'lodash';
import React from 'react';
import ReactDOM from 'react-dom';
import {Link} from '../../common/link/Link';
import {PageTitle} from '../../common/pageTitle/PageTitle';

import statesGetAllHoc from '../../hoc/statesGetAllHoc';
import {stateRoute} from '../../routePaths';

import './statesPage.scss';
import PropTypes from 'prop-types';
// import image from './assets/123_steps_2x.png';
import image from './assets/NEIOverview.png';
import appleLogo from './assets/AppleLogo.png';
import googleLogo from './assets/GoogleLogo.png';
import {Helmet} from 'react-helmet';
import shovelImg from "../home/assets/orange-shovel2.png";
import {getMobileOperatingSystem} from "../../../utils/detectAgent";
/**
 * The StatesPage component.
 *
 * @constructor
 */
export class StatesPage extends React.Component {
  /**
   * @constructor
   * @param {{}} props
   * @param {{}} componentContext
   */
  constructor(props, componentContext) {
    super(props, componentContext);
  }

  /**
   * Triggers before the component is added to the page.
   */
  componentWillMount() {
    this.props.statesGetAllHoc.getAll();
  }

  componentDidMount() {
    // console.log(this.scrollTarget);
    // const scrollTarget = ReactDOM.findDOMNode(this.scrollTarget);
    // console.log(scrollTarget.top);
    // window.scrollTo(0, scrollTarget.offsetTop);


  }

  /**
   * Gets the column lists of states.
   *
   * @param {Array.<{}>} states
   * @returns {Array.<Array.<{}>>}
   */
  getStateColumns = (states) => {
    if (!states || !states.length || !Array.isArray(states)) {
      return [];
    }

    const columnCount = 3;
    const totalCount = states.length;

    let countPerColumn = Math.floor(totalCount / columnCount);
    if (totalCount - (countPerColumn * columnCount)) {
      countPerColumn += 1;
    }

    return lodash.chunk(states, countPerColumn);
  };

  /**
   * Renders the component.
   *
   * @returns {{}}
   */


  render() {
    const isLoading = this.props.statesGetAllHoc.isLoading || false;
    const error = this.props.statesGetAllHoc.error || null;
    const states = this.props.statesGetAllHoc.states;

    const stateColumns = this.getStateColumns(states);

    let userAgent = getMobileOperatingSystem();
    let ctaLink ='';



    if(userAgent=='iOS'){
      ctaLink='https://itunes.apple.com/us/app/safe-excavator/id1323108596?mt=8';
    }

    else{
      ctaLink='https://play.google.com/store/apps/details?id=com.clearlaunch.safeexcavator';
    }

    return (
      <div id="states-page" className="system-page">
        <Helmet>
          <title>Select a state to learn about its laws, resources, and safe digging checklists</title>
          <meta name = "description" content ="Comprehensive list of states and associated links"/>
        </Helmet>
        <div id="app-download-cta-2">
          <div className="container">
            <div className="row">
              <div className="col text-center text-sm-left">
                <a href="https://apps.apple.com/us/app/safe-excavator/id1323108596">
                  <img className="apple-badge" src={appleLogo} alt="apple app store link" />
                </a>
              </div>
              <div className="col text-center text-sm-right">
                <a href="https://play.google.com/store/apps/details?id=com.clearlaunch.safeexcavator&hl=en_US">
                  <img className="apple-badge" src={googleLogo} alt="apple app store link" />
                </a>
              </div>
            </div>
          </div>
        </div>
        <div className="container">
          <div className="row">
            <div className="col">
              <h1 id="myDiv" ref={node => {this.scrollTarget = node;}}>To learn what is required in your state, follow these three easy steps:</h1>
              <div className="text-center">
                <img className="hero" src={image} alt="easy steps" />
              </div>
            </div>
          </div>
          <div id="title-row" className="row-odd row">
            <div className="col">

              <div className="row">
                {(!isLoading && !error && states) && (
                  stateColumns.map((stateColumn, columnIndex) => {
                    return (
                      <div className="col-12 col-md-4" key={columnIndex}>
                        <ul className="state-items">
                          {stateColumn.map((state, stateIndex) => {
                            const stateKey = state.abbreviation.toLowerCase();

                            return (
                              <li className="state-item" key={stateIndex}>
                                <Link className="state-link row" to={stateRoute} params={{state: stateKey}}>
                                  <div className="col-1 col-md-4 text-center pr-0">
                                    <i className={`state-icon sf-${stateKey}`} />
                                  </div>
                                  <div className="col-10 col-md-8 pl-md-0">
                                    <span className="state-name">{state.name}</span>

                                  </div>
                                </Link>
                              </li>
                            );
                          })}
                        </ul>
                      </div>
                    );
                  })
                )}

                {(isLoading) && (
                  <div className="col">
                    <div className="loading">
                      Loading...
                    </div>
                  </div>
                )}

                {(!isLoading && error) && (
                  <div className="alert alert-warning">
                    The states information could not be loaded.
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

StatesPage.propTypes = {
  statesGetAllHoc: PropTypes.shape({
    getAll: PropTypes.func,
    isLoading: PropTypes.bool,
    states: PropTypes.array,
    error: PropTypes.object,
  }),
};

export default statesGetAllHoc(
  StatesPage
);



// WEBPACK FOOTER //
// ./src/components/pages/states/StatesPage.js